export enum ToastPositionType {
    TOP_RIGHT = "top-right",
    TOP_CENTER = "top-center",
    TOP_LEFT = "top-left",
    BOTTOM_RIGHT = "bottom-right",
    BOTTOM_CENTER = "bottom-center",
    BOTTOM_LEFT = "bottom-left",
}
